import { config } from '@services/config';
import { UnderwritingActivityTypeSearchParams, UnderwritingActivityTypeSearchResponse } from '@lio/api-types';
import { queryKeys } from '@services/underwritingReferral';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

const getQueryParams = (params: UnderwritingActivityTypeSearchParams) => {
  const { sort, pageLimit, pageOffset } = params;
  const query = new URLSearchParams();

  if (sort) {
    query.append('sort', sort);
  }

  if (pageLimit) {
    query.append('pageLimit', String(pageLimit));
  }

  if (pageOffset) {
    query.append('pageOffset', String(pageOffset));
  }

  return query.toString();
};

export const useSearchUnderwritingActivityType = () => {
  const client = useClient();

  const query = getQueryParams({ pageLimit: 100 });

  const result = useQuery({
    queryKey: [queryKeys.underwritingActivityType],
    queryFn: async () => {
      const response = await client
        .get(`underwriting-activity-type?${query}`)
        .json<UnderwritingActivityTypeSearchResponse>();
      return response;
    },
    ...config,
  });
  return { ...result, underwritingActivityTypes: result.data?.items };
};
